import { observer } from "mobx-react-lite"
import { SVGPureIcon } from '@/ui';
import historySearchStore from "@/store/historySearch";
import { useEffect, useRef } from "react";
import { Tooltip } from "antd";
const SearchInput = observer((props) => {
  const { searchCloseCb, scene="" } = props
  const inputRef = useRef(null)

  useEffect(() => {
    historySearchStore.reset()
    inputRef?.current?.focus()
    return () => {
      historySearchStore.reset()
    }
  }, [])

  return (
    <div className="h-40px w-full flex items-center">
      <div className="w-196px h-40px border-1px border-black rounded-8px flex items-center">
        <SVGPureIcon 
          name="slider_search"
          className="size-24px ml-10px mr-6px"
        />
        <input 
          type="text" 
          className="w-0 flex-grow text-14px text-black"
          placeholder="搜索对话内容"
          maxLength="20"
          ref={inputRef}
          autoComplete="off"
          value={historySearchStore.data.search}
          onChange={(e) => {
            const value = e.target.value.trim()
            historySearchStore.reset()
            historySearchStore.setData({
              search: value
            })
            if(value) {
              historySearchStore.getList(scene == "aigent" ? 1 : 5)
              return
            }
          }}
        />
        {
          historySearchStore.data.search !== '' ? (
            <Tooltip title="清空输入">
              <span>
                <SVGPureIcon 
                  name="navbar-search-input-clean"
                  className="size-18px ml-8px mr-10px cursor-pointer"
                  onClick={() => {
                    historySearchStore.reset()
                    inputRef?.current?.focus()
                  }}
                />
              </span>
            </Tooltip>
            
          ) : null
        }
      </div>
      <div className="size-32px rounded-6px ml-8px hover:bg-[#00000008] cursor-pointer">
        <Tooltip title="关闭搜索">
          <span>
            <SVGPureIcon 
              name="navbar-search-close"
              className="size-24px ml-4px mt-4px cursor-pointer"
              onClick={() => {
                searchCloseCb && searchCloseCb()
              }}
            />
          </span>
        </Tooltip>
      </div>
    </div>
  )
})

export default SearchInput